// @flow
import I18n from '../i18n';

function formatValue(value: ?number | string, withoutLabel?: boolean): string {
  if (!value) return '';
  if (withoutLabel) {
    return value + '';
  }
  return `${value} ${I18n.t('catalog.SMS_CREDIT')}`;
}

export default formatValue;
